export const cursors: Record<string, string> = {
    default: "_",
    line: "|",
}
